// @core/api/endpoints/workflow/cancel_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelExecutionRequest,
  PipelineExecutionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Cancel execution
 * Cancels a running pipeline execution. Nodes that are currently executing will be allowed to complete, but no new nodes will start.
 */
export async function CancelExecution(
  execution_id: string,
  data: CancelExecutionRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id/cancel`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
